import { CalendarDefault } from './calendar-default.component';

export * from './calendar-default.component';
export default CalendarDefault;

if (!customElements.get('der-tm-roundtrip-offer-panel-calendar-default')) {
    customElements.define('der-tm-roundtrip-offer-panel-calendar-default', CalendarDefault);
}
